// Routes this page does NOT serve → the page that does (DR-0045 D3/D4).
// Import-free on purpose: main.ts uses it on the pre-boot redirect path, which
// must stay feather-light (no engine, no core graph).
export const FOREIGN_ROUTES: Readonly<Record<string, string>> = Object.fromEntries(
  ["wave-lobby", "wave-game", "wave-solo", "local-combat-benchmark", "mobile-foundation-benchmark"].map(
    (route) => [route, "/firestrike/"],
  ),
);
